<template>
    <b-modal
        id="assignment-description-modal"
        v-model="modal"
        :title="$t('common.description')"
        size="md"
        ok-only
        :ok-title="$t('common.close')"
        modal-class="apprentice-default-modal">
        <div
            class="video"
            v-if="videoSource">
            <design-2021-apprentice-video-player-component :options="src(videoSource.file)">
            </design-2021-apprentice-video-player-component>
        </div>

        <design-2021-apprentice-display-html-component
            class="description"
            :html-content="description"></design-2021-apprentice-display-html-component>
    </b-modal>
</template>

<script>
    export default {
        name: 'design-2021-shared-assignment-description-modal-component',
        data() {
            return {
                description: '',
                videoSource: null,
                modal: false,
            };
        },
        methods: {
            show(assignment) {
                this.videoSource = null;
                this.description = assignment.description;

                if (assignment.video) {
                    this.videoSource = assignment.video;
                }

                this.modal = true;
            },
            videoFormatSupported(file) {
                if (
                    file.extension.toLowerCase() === 'ogv' ||
                    file.extension.toLowerCase() === 'ogg' ||
                    file.extension.toLowerCase() === 'mov' ||
                    file.extension.toLowerCase() === 'mp4' ||
                    file.extension.toLowerCase() === 'm4v' ||
                    file.extension.toLowerCase() === 'webm'
                ) {
                    return true;
                }

                return false;
            },
            src(file) {
                // todo check for unsuported video files
                let ext = file.extension;
                if (ext === 'ogv') {
                    ext = 'ogg';
                }
                if (ext === 'mov' || ext === 'MOV') {
                    ext = 'mp4';
                }

                return {
                    autoplay: false,
                    controls: true,
                    sources: [
                        {
                            type: 'video/' + ext,
                            src: file.public_path,
                        },
                    ],
                };
            },
        },
    };
</script>

<style scoped lang="scss">
    .video {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }

    .video-not-supported {
        display: flex;
        justify-content: flex-start;
        justify-content: flex-start;
        flex-direction: column;
    }

    .video-not-supported-info {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
    }

    .btn-video-download {
        align-self: flex-end;
    }

    .description {
        color: $text-muted-color;
        font-size: $default-font-size;
        line-height: 1.3;
    }
</style>
